"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6829],{

/***/ 60245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iy": function() { return /* binding */ postCommonDelivery; },
/* harmony export */   "KZ": function() { return /* binding */ postCommonBoard; },
/* harmony export */   "cA": function() { return /* binding */ postCommonFiles; },
/* harmony export */   "gB": function() { return /* binding */ postCommonReceipt; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



// 공통 - 택배 배송 조회
var postCommonDelivery = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    res = (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].DELIVERY */ .Z.DELIVERY).post(body);
                    if (!(res.status === 200)) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : res.data);
                case 5:
                    return _ctx.abrupt("return", res);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postCommonDelivery(body) {
        return _ref.apply(this, arguments);
    };
}();
// 공통 - 주문 영수증 보기
var postCommonReceipt = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    res = (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].RECEIPT */ .Z.RECEIPT).post(body);
                    if (!(res.status === 200)) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : res.data);
                case 5:
                    return _ctx.abrupt("return", res);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postCommonReceipt(body) {
        return _ref.apply(this, arguments);
    };
}();
// 공통 - 채널 제휴문의
var postCommonBoard = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    res = (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].COMMON_BOARD */ .Z.COMMON_BOARD).post(body);
                    if (!(res.status === 200)) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : res.data);
                case 5:
                    return _ctx.abrupt("return", res);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postCommonBoard(body) {
        return _ref.apply(this, arguments);
    };
}();
// 공통 - 파일
var postCommonFiles = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    res = (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].COMMON_FILES */ .Z.COMMON_FILES).post(body);
                    if (!(res.status === 200)) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 5:
                    return _ctx.abrupt("return", res);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postCommonFiles(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 6829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _api_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60245);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64384);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36968);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 10000001;\n  width: 100vw;\n  height: 100vh;\n\n  & strong {\n    color: #e74c3c;\n  }\n\n  .modal-section {\n    position: fixed;\n    top: ",
        ";\n    left: 40vw;\n    width: 30vw;\n    height: ",
        ";\n    background-color: white;\n    border-radius: 20px;\n    overflow: auto;\n    border: none;\n    display: flex;\n    flex-direction: column;\n\n    @media only screen and (min-width: 1401px) and (max-width: 1600px) {\n      left: 35vw;\n      width: 30vw;\n    }\n\n    @media only screen and (min-width: 1200px) and (max-width: 1400px) {\n      left: 30vw;\n      width: 40vw;\n    }\n\n    @media only screen and (min-width: 992px) and (max-width: 1200px) {\n      left: 30vw;\n      width: 40vw;\n    }\n\n    @media only screen and (min-width: 768px) and (max-width: 991px) {\n      left: 25vw;\n      width: 50vw;\n    }\n\n    @media only screen and (min-width: 576px) and (max-width: 767px) {\n      left: 17vw;\n      width: 66vw;\n    }\n\n    @media only screen and (max-width: 575px) {\n      left: 5vw;\n      width: 90vw;\n    }\n\n    & > i {\n      font-size: 2rem;\n      color: black;\n      cursor: pointer;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n  }\n\n  .modal-header {\n    font-size: 1.2rem;\n    font-weight: 500;\n    color: #253d4e;\n\n    @media only screen and (max-width: 575px) {\n      font-size: 1rem;\n    }\n\n    & i {\n      font-size: 14px;\n      color: #253d4e;\n      border: 2px solid #253d4e;\n      border-radius: 50%;\n      cursor: pointer;\n      height: 25px;\n      width: 25px;\n      display: flex;\n      justify-content: center;\n      align-content: center;\n\n      :hover {\n        color: #3bb77e;\n        border: 2px solid #3bb77e;\n      }\n\n      @media only screen and (max-width: 575px) {\n        font-size: 12px;\n      }\n    }\n  }\n\n  .modal-content {\n    width: 100%;\n    /* height: calc(70vh - 63px); */\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n    border: none;\n    margin: 0 auto;\n    overflow-y: auto;\n    & > span {\n      color: black;\n    }\n\n    .status-top-wrapper {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      margin-top: 2rem;\n\n      h4 {\n        @media only screen and (max-width: 575px) {\n          font-size: 18px;\n        }\n      }\n\n      .shipping-invoice {\n        padding-top: 5px;\n        font-size: 16px;\n        font-weight: 500;\n        color: #253d4e;\n      }\n    }\n\n    .status-btm-wrapper {\n      display: flex;\n      flex-direction: column;\n\n      .loading {\n        margin-top: 100px !important;\n      }\n      .box-wrapper {\n        padding-top: 10px;\n\n        :first-child {\n          padding-top: 1rem;\n        }\n      }\n\n      .box-border {\n        border: 1px solid #ececec;\n        padding: 1rem;\n      }\n\n      .width-flex-full {\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n      }\n\n      .width-70 {\n        width: 70%;\n      }\n\n      .box-header {\n        color: #253d4e;\n        font-weight: 500;\n        word-break: keep-all;\n\n        @media only screen and (max-width: 575px) {\n          font-size: 14px;\n          font-weight: 600;\n        }\n      }\n\n      .box-sub-title {\n        font-size: 14px;\n\n        @media only screen and (max-width: 575px) {\n          font-size: 12px;\n          font-weight: 600;\n        }\n      }\n\n      .width-30 {\n        display: flex;\n        justify-content: end;\n        align-items: center;\n      }\n\n      .date-time {\n        text-align: end;\n        font-weight: 500;\n        color: #3bb77e;\n        word-break: keep-all;\n\n        @media only screen and (max-width: 575px) {\n          font-size: 12px;\n          font-weight: 600;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var ModalWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aca39348-0"
})(_templateObject(), function(props) {
    return props.onShipping ? "15vh" : "30vh";
}, function(props) {
    return props.onShipping ? "70vh" : "40vh";
});
var OrderTrackingModal = function(param) {
    var orderData = param.orderData, onClickOrderTrackingModal = param.onClickOrderTrackingModal, dummyList = param.dummyList;
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), shippingList = ref5[0], setShipplingList = ref5[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), deliveryList = ref1[0], setDeliveryList = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), deliveryLoading = ref2[0], setDeliveryLoading = ref2[1];
    globalThis.onkeydown = function(e) {
        if (e.code === "Escape") return onClickOrderTrackingModal();
    };
    // 렌더링 시 주문 상태, 택배사 정보 목데이터 가져오는 함수
    var getDeliveryList = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var deliveryDummyList, tempDeliveryArr, key;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        deliveryDummyList = dummyList === null || dummyList === void 0 ? void 0 : dummyList.delivery;
                        tempDeliveryArr = [];
                        for(key in deliveryDummyList){
                            tempDeliveryArr.push({
                                value: key,
                                label: deliveryDummyList[key]
                            });
                        }
                        setDeliveryList(tempDeliveryArr);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getDeliveryList() {
            return _ref.apply(this, arguments);
        };
    }();
    // 배송상태 리스트 가져오기
    var getShippingTracking = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var body, res, ref, ref3, ref4;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setDeliveryLoading(true);
                        body = {
                            modes: "Check",
                            deliverycode: orderData === null || orderData === void 0 ? void 0 : orderData.delivery,
                            deliverynum: orderData === null || orderData === void 0 ? void 0 : orderData.deliverynum
                        };
                        _ctx.next = 4;
                        return (0,_api_common__WEBPACK_IMPORTED_MODULE_4__/* .postCommonDelivery */ .Iy)(body);
                    case 4:
                        res = _ctx.sent;
                        if ((res === null || res === void 0 ? void 0 : res.status) === 200) {
                            ;
                            if ((res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.Code) === "0000") {
                                ;
                                setShipplingList(res === null || res === void 0 ? void 0 : (ref3 = res.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.Data) === null || ref4 === void 0 ? void 0 : ref4.Rows);
                            }
                        }
                        setDeliveryLoading(false);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getShippingTracking() {
            return _ref.apply(this, arguments);
        };
    }();
    // deliveryList 에서 현재 value 와 비교 후 label 을 찾는 함수
    var getLabelFromDeliveryList = function(data) {
        if (deliveryList !== undefined) {
            var ref;
            return (ref = deliveryList.find(function(el) {
                return el.value === data;
            })) === null || ref === void 0 ? void 0 : ref.label;
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        getDeliveryList();
        getShippingTracking();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ModalWrapper, {
            onShipping: (shippingList === null || shippingList === void 0 ? void 0 : shippingList.length) > 3 ? true : false,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "modal-section",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "modal-header",
                        children: [
                            "\uBC30\uC1A1 \uC870\uD68C",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                className: "fi-rs-cross",
                                onClick: onClickOrderTrackingModal
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "modal-content",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "status-top-wrapper",
                                children: [
                                    (orderData === null || orderData === void 0 ? void 0 : orderData.deliverystats) === "1" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h4", {
                                        children: "\uD604\uC7AC \uBC30\uC1A1 \uB300\uAE30 \uC911 \uC785\uB2C8\uB2E4."
                                    }),
                                    (orderData === null || orderData === void 0 ? void 0 : orderData.deliverystats) === "2" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h4", {
                                        children: "\uD604\uC7AC \uBC30\uC1A1 \uC911 \uC785\uB2C8\uB2E4."
                                    }),
                                    (orderData === null || orderData === void 0 ? void 0 : orderData.deliverystats) === "3" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h4", {
                                        children: "\uBC30\uC1A1 \uC644\uB8CC \uB418\uC5C8\uC2B5\uB2C8\uB2E4."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "shipping-invoice",
                                        children: [
                                            [
                                                getLabelFromDeliveryList(orderData === null || orderData === void 0 ? void 0 : orderData.delivery)
                                            ],
                                            " ",
                                            (orderData === null || orderData === void 0 ? void 0 : orderData.deliverynum) && (orderData === null || orderData === void 0 ? void 0 : orderData.deliverynum)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "status-btm-wrapper pt-5 mt-5",
                                children: deliveryLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "loading m-auto d-flex align-items-center justify-content-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        animation: "border",
                                        role: "status"
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    children: (orderData === null || orderData === void 0 ? void 0 : orderData.delivery) && (orderData === null || orderData === void 0 ? void 0 : orderData.deliverynum) ? shippingList === null || shippingList === void 0 ? void 0 : shippingList.map(function(el, i) {
                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "box-wrapper",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "box-border",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "width-flex-full",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                            className: "width-70",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                                    className: "box-header",
                                                                    children: el === null || el === void 0 ? void 0 : el.stats
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                                    className: "box-sub-title",
                                                                    children: el === null || el === void 0 ? void 0 : el.place
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                            className: "width-30",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                                className: "date-time",
                                                                children: el === null || el === void 0 ? void 0 : el.time
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        }, i);
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "box-wrapper",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            className: "text-center pb-20",
                                            children: "\uBC30\uC1A1 \uC2DC\uC791 \uD6C4 \uC0C1\uD0DC\uAC00 \uC5C5\uB370\uC774\uD2B8 \uB429\uB2C8\uB2E4."
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var mapStateToProps = function(state) {
    return {
        dummyList: state.dummyList
    };
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .connect */ .$j)(mapStateToProps, null)(OrderTrackingModal));


/***/ })

}]);